import { blobticService } from '../../Commun/services/blobticService';

export interface GammeDto {
    GAM_IDF: number;
    GAM_CODE: string;
    GAM_LIB: string;
    GAM_DESCRIPTION?: string;
    LAST_UPDT?: string;
}

export interface Gamme {
    id: number;
    code: string;
    name: string;
    description?: string;
    lastUpdate?: string;
}

const mapDtoToModel = (dto: GammeDto): Gamme => ({
    id: dto.GAM_IDF,
    code: dto.GAM_CODE,
    name: dto.GAM_LIB,
    description: dto.GAM_DESCRIPTION,
    lastUpdate: dto.LAST_UPDT
});

const mapModelToDto = (model: Partial<Gamme>): Partial<GammeDto> => ({
    GAM_IDF: model.id,
    GAM_CODE: model.code,
    GAM_LIB: model.name,
    GAM_DESCRIPTION: model.description,
});

export const gammeApi = {
    getAll: async () => {
        // Calling Gamme through Blobtic_Parameters via its object name 'gamme'
        const response = await blobticService.executeZoomRequest<GammeDto[]>({
            ZoomKey: 'Blobtic_Parameters',
            Action: { OKey: 'Blobtic_Parameters,gamme,Select' }
        });
        return { data: (response.data || []).map(mapDtoToModel) };
    },

    getById: async (id: number) => {
        const response = await blobticService.executeZoomRequest<GammeDto[]>({
            ZoomKey: 'Blobtic_Parameters',
            Action: {
                OKey: 'Blobtic_Parameters,gamme,Select',
                GAM_IDF: id
            }
        });
        const dto = response.data?.[0];
        return { data: dto ? mapDtoToModel(dto) : null };
    },

    create: async (gamme: Partial<Gamme>) => {
        const dto = mapModelToDto(gamme);
        const response = await blobticService.executeZoomRequest<GammeDto[]>({
            ZoomKey: 'Blobtic_Parameters',
            Action: {
                OKey: 'Blobtic_Parameters,gamme,Insert',
                ...dto
            }
        });
        return {
            data: response.data?.[0] ? mapDtoToModel(response.data[0]) : null,
            message: response.message
        };
    },

    update: async (id: number, gamme: Partial<Gamme>) => {
        const dto = mapModelToDto(gamme);
        const response = await blobticService.executeZoomRequest<GammeDto[]>({
            ZoomKey: 'Blobtic_Parameters',
            Action: {
                OKey: 'Blobtic_Parameters,gamme,Update',
                GAM_IDF: id,
                ...dto
            }
        });
        return {
            data: response.data?.[0] ? mapDtoToModel(response.data[0]) : null,
            message: response.message
        };
    },

    delete: async (id: number) => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parameters',
            Action: {
                OKey: 'Blobtic_Parameters,gamme,Delete',
                GAM_IDF: id
            }
        });
        return {
            success: true,
            message: response.message
        };
    }
};
